export enum PatchOperation {
    Update = "update",
    InsertBefore = "insertBefore",
    InsertAfter = "insertAfter",
    Remove = "remove",
    Add = "add"
}
